function maskPhoneNumber(phoneNumber, fallbackValue = "") {
  if ((phoneNumber == null ? void 0 : phoneNumber.length) !== 10) {
    return phoneNumber || fallbackValue;
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
}
function sanitizeNumberValue(value) {
  if (!value)
    return value;
  return value.replace(/\D/g, "");
}
const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
function capitalizeSentence(str) {
  if (!str)
    return "";
  const split = str.split(" ");
  if (split.length > 1) {
    return split.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
function formatErrorClassName(errorName) {
  return `${capitalize(errorName)}Error`;
}
function formatGraphQLErrorClassName(errorName) {
  return `${capitalize(errorName)}GraphQLError`;
}
function formatUSAddress({
  address,
  city,
  stateCode,
  zipCode
}) {
  return `${capitalizeSentence(address) ?? ""} ${capitalizeSentence(city) ?? ""} ${(stateCode == null ? void 0 : stateCode.toUpperCase()) ?? ""} ${(zipCode == null ? void 0 : zipCode.toUpperCase()) ?? ""}`.trim();
}
function formatPatientName(patientDetails) {
  if (!patientDetails)
    return "";
  return `${patientDetails == null ? void 0 : patientDetails.firstName} ${(patientDetails == null ? void 0 : patientDetails.middleName) ?? ""} ${patientDetails == null ? void 0 : patientDetails.lastName}`;
}
export {
  formatGraphQLErrorClassName as a,
  formatUSAddress as b,
  capitalizeSentence as c,
  formatPatientName as d,
  formatErrorClassName as f,
  maskPhoneNumber as m,
  sanitizeNumberValue as s
};
//# sourceMappingURL=formatUtils-L5BIcPiS.js.map
